import { render, staticRenderFns } from "./AsignacionPantalla.vue?vue&type=template&id=7f2c53aa&scoped=true&"
import script from "./AsignacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./AsignacionPantalla.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionPantalla.vue?vue&type=style&index=0&id=7f2c53aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2c53aa",
  null
  
)

export default component.exports